import { materialSizes } from '../../hooks/editor.js'

export default function getConfigFormRules() {
  function validateSizeRange(value1, value2) {
    let msg = ''
    if ([value1, value2].some(s => !s || !String(s).trim())) {
      msg = '请输入字幕距底部距离'
    }
    if (isNaN(value1) || isNaN(value2)) {
      msg = '请输入数字'
    }
    return msg
  }
  return {
    // 重复度验证
    duplicateNum: [
      { required: true, message: '请输入同素材组合次数上限', trigger: 'blur' },
      { type: 'number', message: '请输入数字', trigger: 'blur', transform: value => Number(value) },
      { type: 'number', min: 1, max: 100, message: '次数应在1-100之间', trigger: 'blur', transform: value => Number(value) }
    ],

    // A段视频验证
    materialPoolA: [
      { required: true, message: '请上传A段视频素材', trigger: 'change' },
      { type: 'array', min: 1, message: '至少上传一个A段视频素材', trigger: 'change' }
    ],

    // B段视频验证
    materialPoolB: [
      { required: true, message: '请上传B段视频素材', trigger: 'change' },
      { type: 'array', min: 1, message: '至少上传一个B段视频素材', trigger: 'change' }
    ],

    // 背景包边开关验证 - 一般不需要验证开关，但如果需要可以添加
    background: [
      {
        validator: (rule, value, callback) => {
          if (!value.imgs?.length) {
            return callback(new Error('请上传包边图片'))
          }

          // 必须选择横版1280*720 和 竖版720*1280的两个图片
          const sizes = materialSizes.map((s) => s.label)
          const selectedSizes = [...new Set(value.imgs.map((img) => `${img.width}*${img.height}`))]
          for (let i = 0; i < sizes.length; i++) {
            const size = sizes[i]
            if (!selectedSizes.includes(size)) {
              return callback(new Error('包边图片必须选择720*1280和1280*720两个尺寸'))
            }
          }
          callback()
        }
      }
    ],

    watermark: [
      {
        required: true,
        validator: (rule, value, callback) => {
          console.log('watermark value output: ', value)
          if (!value.img?.id) {
            return callback(new Error('请上传水印图片'))
          }

          callback()
        }
      }
    ],
    'subtitleStyle.subtitleStyleFontSize': [
      {
        required: true,
        validator: (rule, value, callback) => {
          const { subtitleStyleFontSizeH, subtitleStyleFontSizeV } = this.value.subtitleStyle
          const msg = validateSizeRange(subtitleStyleFontSizeH, subtitleStyleFontSizeV)
          console.log('msg output: ', msg)
          msg ? callback(new Error(msg)) : callback()
        }
      }
    ],
    'subtitleStyle.subtitleStyleBottom': [
      {
        required: true,
        validator: (rule, value, callback) => {
          const { subtitleStyleBottomH, subtitleStyleBottomV } = this.value.subtitleStyle
          const msg = validateSizeRange(subtitleStyleBottomH, subtitleStyleBottomV)
          msg ? callback(new Error(msg)) : callback()
        }

      }],
    'warnings.warningsFontSize': [
      {
        required: true,
        validator: (rule, value, callback) => {
          const { warningsFontSizeH, warningsFontSizeV } = this.value.warnings
          const msg = validateSizeRange(warningsFontSizeH, warningsFontSizeV)
          msg ? callback(new Error(msg)) : callback()
        }
      }
    ],
    'warnings.warningsBottom': [{
      required: true,
      validator: (rule, value, callback) => {
        const { warningsBottomH, warningsBottomV } = this.value.warnings
        const msg = validateSizeRange(warningsBottomH, warningsBottomV)
        msg ? callback(new Error(msg)) : callback()
      }
    }],
    'warnings.warningsContent': [
      { required: true, message: '请输入警示语内容', trigger: 'change' },
      { min: 1, max: 100, message: '字数应在1~100之间', trigger: 'blur' }
    ],

    videoRatio: [
      {
        required: true,
        validator: (rule, value, callback) => {
          if (!value?.length) {
            return callback(new Error('请至少选择一个视频比例'))
          }
          const [firstRatio] = value
          if (firstRatio === 0) {
            return callback(new Error('请至少选择一个视频比例'))
          }
          callback()
        }
      }
    ],

    // 视频命名验证
    taskName: [
      {
        validator: (rule, value, callback) => {
          const { imageName, imageNameStartNum } = value || {}

          if (!imageName) {
            callback(new Error('请输入视频命名前缀'))
          } else if (!imageNameStartNum) {
            callback(new Error('请输入视频命名起始数字'))
          } else if (!/^\d+$/.test(imageNameStartNum)) {
            callback(new Error('起始数字必须为纯数字'))
          }

          callback()
        },
        trigger: 'blur'
      }
    ]
  }
}
